import React from "react"
import {FieldManagementPreviewProps} from "../../../render/management-preview";
import PillUser from "../../../../gd-components/molecules/pill/pill-user";

export default function FieldUsers_ManagementPreview(props: FieldManagementPreviewProps) {

    let userIds;
    if (props.field.options && props.field.options.length > 1)
        userIds = _.map(_.slice(props.field.options, 0, 2), option=>option.value);
    else
        userIds = [gd.user.id];

    return (
        <div className={Classes("ui5-txt-default", "fl-ac", "max-w-300", "fl-wrap", "m-t-4", "m-b-4")}>
            {_.map(userIds, userId => {

                return  <PillUser key    =   {userId}
                                  userId =   {userId}
                                  size   =   {26}/>

                // return <UsersMultiselectOptionPill key={userId} userId={userId}/>
            })}
        </div>
    )


}
